<div id="trajectory" class="container mx-auto" data-cy="trajectory">
  <div class="form" [formGroup]="control">
    <ife-title
      [title]="'modules.evcQuote.steps.technicalDetails.steps.trajectory.title' | translate"
      data-cy="charging-station-placement-title"
    ></ife-title>
    <p
      class="text-center mb-8"
      [innerHTML]="'modules.evcQuote.steps.technicalDetails.steps.trajectory.description' | translate"
    ></p>
    <!-- Mobile image picker -->
    <div class="block md:hidden">
      <app-multiple-image-picker
        [baseUrl]="baseUrl"
        [images]="control.get('images')"
        [numberOfImages]="3"
        (removeImage)="removeImageAtIndex($event)"
        (addNewImage)="addNewImage($event)"
      >
      </app-multiple-image-picker>
    </div>

    <!-- Desktop image picker -->
    <div id="images" data-cy="images" class="hidden md:flex flex-wrap justify-center items-center px-16">
      <div
        class="my-16 flex flex-col sm:mx-6 items-center justify-self-center"
        *ngFor="let image of [1, 2, 3]; index as i"
      >
        <ife-image-picker
          class="w-full sm:w-max mb-4"
          [imageUrl]="control.get('images').value[i] ? baseUrl + control.get('images').value[i] : null"
          (selectImage)="addNewImage($event)"
        >
        </ife-image-picker>
        <div class="h-6 w-full">
          <button
            class="btn-secondary py-8 block bottom-8 w-full"
            *ngIf="control.get('images').value[i]"
            (click)="removeImageAtIndex(i)"
            [attr.data-cy]="'remove-image-' + image"
          >
            {{ "modules.evcQuote.general.deletePicture" | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Text field describe trajectory -->
    <div class="max-w-4xl mx-auto mt-16">
      <div class="form-element textarea">
        <div class="flex">
          <label>
            {{ "modules.evcQuote.steps.technicalDetails.steps.trajectory.fields.description" | translate }}
          </label>
          <app-tooltip
            data-cy="tooltip"
            [content]="'modules.evcQuote.steps.technicalDetails.steps.trajectory.fields.descriptionTooltip' | translate"
          >
          </app-tooltip>
        </div>
        <textarea
          id="description"
          type="text"
          formControlName="description"
          data-cy="input-description"
          [placeholder]="
            'modules.evcQuote.steps.technicalDetails.steps.trajectory.fields.descriptionPlaceholder' | translate
          "
        ></textarea>
      </div>

      <!-- Text field more info -->
      <div class="form-element textarea mt-8">
        <div class="flex">
          <label>
            {{ "modules.evcQuote.steps.technicalDetails.steps.trajectory.fields.moreInfo" | translate }}
          </label>
          <app-tooltip
            data-cy="tooltip"
            [position]="'left'"
            [content]="'modules.evcQuote.steps.technicalDetails.steps.trajectory.fields.moreInfoTooltip' | translate"
          >
          </app-tooltip>
        </div>
        <textarea
          id="more-info"
          type="text"
          formControlName="moreInfo"
          data-cy="input-more-info"
          [placeholder]="
            'modules.evcQuote.steps.technicalDetails.steps.trajectory.fields.moreInfoPlaceholder' | translate
          "
        ></textarea>
      </div>
    </div>

    <!-- QR Code part -->
    <div *ngIf="arrayLength === 0 && isDesktopDevice" class="flex flex-col max-w-max mx-auto">
      <div class="line"></div>
      <p class="text-left sm:text-center my-12">{{ "modules.evcQuote.general.qrcodeInfo" | translate }}</p>
      <div class="qr-section max-w-max mx-auto shadow-lg rounded-lg overflow-hidden">
        <qrcode
          data-cy="qrcode"
          [qrdata]="href"
          [width]="160"
          [errorCorrectionLevel]="'M'"
          [elementType]="'svg'"
        ></qrcode>
      </div>
    </div>
    <!-- Show next when at least one image has been uploaded -->
    <ife-navigation
      [showNext]="arrayLength >= 1"
      [showPrevious]="true"
      [showContinueLater]="arrayLength !== 3"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
      (continueLaterStep)="goToContinueLater()"
    >
    </ife-navigation>
  </div>
</div>
